module.exports = __webpack_public_path__ + "img/18.5dbb15e2.png";